module.exports = __webpack_public_path__ + "img/banner.cdac7799.jpg";